export default __webpack_public_path__ + "static/media/bg-adm.ca749594.png";